import React from 'react';
import {
  Stack,
  TextField,
  InputAdornment,
  Typography,
  Box,
} from '@mui/material';

import { Search, SlowMotionVideo } from '@mui/icons-material';

const GuideVideoFilters = ({ onSearchChange, children }) => {
  return (
    <Stack spacing={4} sx={{ mb: 6 }}>

      <Stack direction="row" justifyContent="space-between" alignItems="center">

        <Box>
          <Stack direction="row" spacing={1} alignItems="center">
            <SlowMotionVideo sx={{ color: '#4318FF' }} />
            <Typography sx={{ color: '#4318FF', fontWeight: 800 }}>
              Guide Vidéo
            </Typography>
          </Stack>

          <Typography variant="h4" sx={{ fontWeight: 900 }}>
            Guide Manager
          </Typography>
        </Box>

        {children}

      </Stack>

      <TextField
        placeholder="Rechercher un guide..."
        onChange={(e) => onSearchChange(e.target.value)}
        fullWidth
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Search sx={{ color: '#A3AED0' }} />
            </InputAdornment>
          ),
        }}
      />

    </Stack>
  );
};

export default GuideVideoFilters;